import { Col, Image, Row } from 'antd';
import type { File } from '../../types';

const ReadOnlyFileUrlGallery = ({ images }: { images?: File[] }) => {
  if (images?.length) {
    return (
      <Image.PreviewGroup>
        <Row gutter={[8, 8]}>
          {images.map((img) => (
            <Col key={img.id} span={12}>
              <Image
                src={img.url}
                width="100%"
                style={{ aspectRatio: 1, objectFit: 'cover' }}
                fallback="/placeholder.png"
              />
            </Col>
          ))}
        </Row>
      </Image.PreviewGroup>
    );
  }
  return (
    <Image
      src={undefined}
      preview={false}
      fallback="/placeholder.png"
      width={200}
      height={150}
    />
  );
};

export default ReadOnlyFileUrlGallery;
